define(
    'views/admin_awards.view',[
        'loader',
        'config',
        'helper',
        'sandbox',

        'text!templates/admin_awards.html',
        'text!templates/admin_awards_item.html'
    ],
    function(Loader, Config, Helper, Sandbox, adminAwardsTemplate, adminAwardsItemTemplate)
    {
        var $ = Loader.$;
        var _ = Loader._;

        var AdminAwardsView = Loader.Backbone.View.extend(
            {

                list: [],
                awards: [],
                limit: 100,
                offset: 0,
                loadInProcess: false,

                events: Helper.prepareEventsForDevice(
                    {
                        'click .save-awards-settings': 'saveSettings',
                        'click #pun-admin-award-form .bg': 'hideForm',
                        'click #award-form-send': 'send',
                        'click #award-form-close': 'hideForm',
                        'click #award-create': 'addAward',
                        'click .award-edit': 'editAward',
                        'click .award-delete': 'deleteAward',
                        'click #load-more-awards': 'loadMore'
                    },
                    Loader.eventType
                ),

                routes: {
                    "/admin_index.php[?+]act=awards": "preparePage"
                },

                initialize: function()
                {
                    var _this = this;
                    _.bindAll(this, 'render');
                    var user =  this.model.get('users').getMe();

                    this.model.on('startApplication', function(){
                        if ((user.get('groupId') == 1)){

                            Helper.filterRoutes(_this.routes, _this);

                            _this.model.get('adminMenuLinks').add([{
                                id: 'awards-link',
                                className: 'item22',
                                title: 'Награды',
                                href: '/admin_index.php?act=awards',
                                indicator: 0,
                                position: 22,
                                isActive: (document.location.href.indexOf('?act=awards') != -1)
                            }]);

                            // TODO: временное решение. Перенести в Подарки, когда будет переписано
                            _this.model.get('adminMenuLinks').add([{
                                id: 'gifts-link',
                                className: 'item23',
                                title: 'Подарки',
                                href: '/admin_index.php?act=gifts',
                                indicator: 0,
                                position: 23,
                                isActive: (document.location.href.indexOf('?act=gifts') != -1)
                            }]);
                        }
                    });
                },

                render: function(global)
                {
                    if (global) return this;

                    var _this = this;
                    var elem = $("#pun-admain1");

                    var compiledTemplate = _.template(
                        adminAwardsTemplate,
                        {
                            model: this.model.toJSON(),
                            user: this.model.get('users').getMe().toJSON(),
                            awards: [],
                            Helper: Helper,
                            Config: Config
                        }
                    );

                    elem.html(compiledTemplate);
                    return this;
                },

                renderAwardsItems: function (items, append, showNoAwards) {
                    if (typeof showNoAwards == 'undefined') showNoAwards = true;

                    var compiledTemplate = _.template(
                        adminAwardsItemTemplate,
                        {
                            model: this.model.toJSON(),
                            awards: items,
                            showNoAwards: showNoAwards,
                            Config: Config,
                            Helper: Helper
                        }
                    );

                    if (!append)
                        this.$el.find("#awards-content").html(compiledTemplate);
                    else
                        this.$el.find("#awards-content").append(compiledTemplate);

                    if ((Helper.getParam('uid') > 0 && items[0] && items[0].awards.length < this.limit) || items.length < this.limit)
                        this.$el.find('#load-more-awards').hide();

                    this.delegateEvents();
                },

                getAwards: function (data, callback, silent) {
                    if (!data) data = {};
                    if (!data.limit) data.limit = this.limit;
                    if (!data.offset) data.offset = this.offset;
                    this.model.get('awards').getAwards(data, function(data){
                        callback(data);
                    }.bind(this), silent);
                },

                loadMore: function () {
                    if (this.loadInProcess) return;
                    this.loadInProcess = true;
                    this.offset+=this.limit;
                    this.$el.find('#load-more-awards').html('Загружаю...');
                    this.getAwards({limit: this.limit, offset: this.offset, sort: 'list'}, function(items) {
                        this.awards = this.awards.concat(_.sortBy(items, function(item){return +item.id}));
                        this.renderAwardsItems(items, true, false);
                        this.loadInProcess = false;
                        this.$el.find('#load-more-awards').html('Показать еще');
                        if (items.length < this.limit)
                            this.$el.find('#load-more-awards').hide();
                    }.bind(this), true);
                },

                preparePage: function()
                {
                    var _this = this;
                    document.title = 'Администрирование — Награды';

                    this.render();

                    this.getAwards({
                        sort: "list"
                    }, function(data){
                        _this.awards = _.sortBy(data, function(item){return +item.id});
                        _this.renderAwardsItems(_this.awards);
                    });
                },

                saveSettings: function(e)
                {
                    var _this = this;

                    this.model.get('awards').saveSettings({
                        board_award_use_mod: $('[name=award_use_mod]:checked').val(),
                        board_award_use_moderate: $('[name=award_use_moderate]:checked').val(),
                        board_award_sort: $('[name=award_sort]').val(),
                        board_award_echo_awards: $('[name=award_echo_awards]:checked').val(),
                        board_award_echo_without_awards: $('[name=award_echo_without_awards]:checked').val(),
                        board_award_detail: $('[name=award_echo_detail]:checked').val()
                    }, function(){
                        _this.model.get('forum').collector(function(){
                            document.location.reload();
                        });
                    }, function(){
                        alert('Произошла ошибка при сохранении настроек');
                    });
                },

                hideForm: function()
                {
                    $('#pun-admin-award-form .bg, #pun-admin-award-form .inner').fadeOut('fast');
                },

                showForm: function()
                {
                    $('#pun-admin-award-form .bg, #pun-admin-award-form .inner').fadeIn('fast');
                },

                addAward: function(e)
                {
                    this.emptyForm();
                    this.showForm();
                },

                editAward: function(e)
                {
                    var $elem = $(e.currentTarget);
                    var awardId = $elem.attr('data-id');

                    var award = _.find(this.awards, function(item){
                        return item.id == awardId
                    });

                    if (!award) return;

                    $('#award-id').val(award.id);
                    $('#award-name').val(award.name);
                    $('#award-href').val(award.href);
                    $('#award-desc').val(award.desc);

                    this.showForm();
                },

                emptyForm: function()
                {
                    $('#award-id').val('');
                    $('#award-name').val('');
                    $('#award-href').val('');
                    $('#award-desc').val('');
                },

                deleteAward: function(e)
                {
                    var $elem = $(e.currentTarget);
                    var awardId = $elem.attr('data-id');

                    if (!awardId) return;

                    if(confirm('Вы уверены, что хотите удалить награду? Все выданные пользователям награды будут так же удалены')) {

                        this.model.get('awards').deleteItem({
                            id: awardId
                        }, function(result){
                            if (result.success == true)
                                document.location.reload();
                            else alert('Ошибка запроса. Обратитесь в поддержку или попробуйте позднее');
                        }, function(){
                            alert('Ошибка запроса. Обратитесь в поддержку или попробуйте позднее');
                        });
                    }

                },

                send: function(e)
                {
                    var id   = $('#award-id').val();
                    var name = $('#award-name').val();
                    var href = $('#award-href').val();
                    var desc = $('#award-desc').val();

                    if (name.length == 0 || href.length == 0 || desc.length == 0) {
                        alert('Все поля формы обязательны для заполнения');
                        return false;
                    }

                    this.model.get('awards').item({
                        id: id || null,
                        name: name,
                        href: href,
                        desc: desc
                    }, function(result){
                        if (result.award)
                            document.location.reload();
                        else alert('Ошибка запроса. Обратитесь в поддержку или попробуйте позднее');
                    }, function(){
                        alert('Ошибка запроса. Обратитесь в поддержку или попробуйте позднее');
                    });

                    return true;
                }
            });

        return {
            initialize: function(model)
            {
                return new AdminAwardsView({
                    el: $("#pun-admain"),
                    model: model
                })
            }
        }
    }
);
